module.exports = __webpack_public_path__ + "img/faifap_nuevo_banner.23463bc2.jpg";